export function normalizeStateName(name: string): string {
  return name.toLowerCase().replace(/[^a-z]/g, "");
}

const statesData = [
  {
    name: "Alabama",
    abbreviation: "AL",
    areaCodes: ["205", "251", "256", "334", "938"],
  },
  { name: "Alaska", abbreviation: "AK", areaCodes: ["907"] },
  {
    name: "Arizona",
    abbreviation: "AZ",
    areaCodes: ["480", "520", "602", "623", "928"],
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
    areaCodes: ["479", "501", "870"],
  },
  {
    name: "California",
    abbreviation: "CA",
    areaCodes: [
      "209",
      "213",
      "310",
      "323",
      "408",
      "415",
      "424",
      "442",
      "510",
      "530",
      "559",
      "562",
      "619",
      "626",
      "650",
      "657",
      "661",
      "669",
      "707",
      "714",
      "747",
      "760",
      "805",
      "818",
      "831",
      "858",
      "909",
      "916",
      "925",
      "949",
      "951",
    ],
  },
  {
    name: "Colorado",
    abbreviation: "CO",
    areaCodes: ["303", "719", "720", "970"],
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
    areaCodes: ["203", "475", "860"],
  },
  { name: "Delaware", abbreviation: "DE", areaCodes: ["302"] },
  {
    name: "District of Columbia",
    alternateNames: ["Washington, D.C."],
    abbreviation: "DC",
    areaCodes: ["202"],
  },
  {
    name: "Florida",
    abbreviation: "FL",
    areaCodes: [
      "239",
      "305",
      "321",
      "352",
      "386",
      "407",
      "561",
      "727",
      "754",
      "772",
      "786",
      "813",
      "850",
      "863",
      "904",
      "941",
      "954",
    ],
  },
  {
    name: "Georgia",
    abbreviation: "GA",
    areaCodes: ["229", "404", "470", "478", "678", "706", "762", "770", "912"],
  },
  { name: "Hawaii", abbreviation: "HI", areaCodes: ["808"] },
  { name: "Idaho", abbreviation: "ID", areaCodes: ["208"] },
  {
    name: "Illinois",
    abbreviation: "IL",
    areaCodes: [
      "217",
      "224",
      "309",
      "312",
      "331",
      "618",
      "630",
      "708",
      "773",
      "779",
      "815",
      "847",
      "872",
    ],
  },
  {
    name: "Indiana",
    abbreviation: "IN",
    areaCodes: ["219", "260", "317", "574", "765", "812"],
  },
  {
    name: "Iowa",
    abbreviation: "IA",
    areaCodes: ["319", "515", "563", "641", "712"],
  },
  {
    name: "Kansas",
    abbreviation: "KS",
    areaCodes: ["316", "620", "785", "913"],
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
    areaCodes: ["270", "502", "606", "859"],
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
    areaCodes: ["225", "318", "337", "504", "985"],
  },
  { name: "Maine", abbreviation: "ME", areaCodes: ["207"] },
  {
    name: "Maryland",
    abbreviation: "MD",
    areaCodes: ["240", "301", "410", "443", "667"],
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
    areaCodes: ["339", "351", "413", "508", "617", "774", "781", "857", "978"],
  },
  {
    name: "Michigan",
    abbreviation: "MI",
    areaCodes: [
      "231",
      "248",
      "269",
      "313",
      "517",
      "586",
      "616",
      "734",
      "810",
      "906",
      "947",
      "989",
    ],
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
    areaCodes: ["218", "320", "507", "612", "651", "763", "952"],
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
    areaCodes: ["228", "601", "662", "769"],
  },
  {
    name: "Missouri",
    abbreviation: "MO",
    areaCodes: ["314", "417", "573", "636", "660", "816"],
  },
  { name: "Montana", abbreviation: "MT", areaCodes: ["406"] },
  {
    name: "Nebraska",
    abbreviation: "NE",
    areaCodes: ["308", "402", "531"],
  },
  {
    name: "Nevada",
    abbreviation: "NV",
    areaCodes: ["702", "725", "775"],
  },
  { name: "New Hampshire", abbreviation: "NH", areaCodes: ["603"] },
  {
    name: "New Jersey",
    abbreviation: "NJ",
    areaCodes: ["201", "551", "609", "732", "848", "856", "862", "908", "973"],
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
    areaCodes: ["505", "575"],
  },
  {
    name: "New York",
    abbreviation: "NY",
    areaCodes: [
      "212",
      "315",
      "347",
      "516",
      "518",
      "585",
      "607",
      "631",
      "646",
      "716",
      "718",
      "845",
      "914",
      "917",
      "929",
    ],
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
    areaCodes: ["252", "336", "704", "828", "910", "919", "980", "984"],
  },
  { name: "North Dakota", abbreviation: "ND", areaCodes: ["701"] },
  {
    name: "Ohio",
    abbreviation: "OH",
    areaCodes: [
      "216",
      "234",
      "330",
      "419",
      "440",
      "513",
      "567",
      "614",
      "740",
      "937",
    ],
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
    areaCodes: ["405", "539", "580", "918"],
  },
  {
    name: "Oregon",
    abbreviation: "OR",
    areaCodes: ["458", "503", "541", "971"],
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
    areaCodes: [
      "215",
      "267",
      "272",
      "412",
      "484",
      "570",
      "610",
      "717",
      "724",
      "814",
      "878",
    ],
  },
  { name: "Rhode Island", abbreviation: "RI", areaCodes: ["401"] },
  {
    name: "South Carolina",
    abbreviation: "SC",
    areaCodes: ["803", "843", "864"],
  },
  { name: "South Dakota", abbreviation: "SD", areaCodes: ["605"] },
  {
    name: "Tennessee",
    abbreviation: "TN",
    areaCodes: ["423", "615", "731", "865", "901", "931"],
  },
  {
    name: "Texas",
    abbreviation: "TX",
    areaCodes: [
      "210",
      "214",
      "254",
      "281",
      "325",
      "346",
      "361",
      "409",
      "430",
      "432",
      "469",
      "512",
      "682",
      "713",
      "737",
      "806",
      "817",
      "830",
      "832",
      "903",
      "915",
      "936",
      "940",
      "956",
      "972",
      "979",
    ],
  },
  {
    name: "Utah",
    abbreviation: "UT",
    areaCodes: ["385", "435", "801"],
  },
  { name: "Vermont", abbreviation: "VT", areaCodes: ["802"] },
  {
    name: "Virginia",
    abbreviation: "VA",
    areaCodes: ["276", "434", "540", "571", "703", "757", "804"],
  },
  {
    name: "Washington",
    abbreviation: "WA",
    areaCodes: ["206", "253", "360", "425", "509"],
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
    areaCodes: ["304", "681"],
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
    areaCodes: ["262", "414", "534", "608", "715", "920"],
  },
  { name: "Wyoming", abbreviation: "WY", areaCodes: ["307"] },

  {
    name: "American Samoa",
    abbreviation: "AS",
    areaCodes: ["684"],
    territory: true,
  },
  {
    name: "Guam",
    abbreviation: "GU",
    areaCodes: ["671"],
    territory: true,
  },
  {
    name: "Northern Marianas Islands",
    abbreviation: "MP",
    areaCodes: ["670"],
    territory: true,
  },
  {
    name: "Puerto Rico",
    abbreviation: "PR",
    areaCodes: ["787", "939"],
    territory: true,
  },
  {
    name: "U.S. Virgin Islands",
    abbreviation: "VI",
    areaCodes: ["340"],
    territory: true,
  },

  {
    name: "Armed Forces: Europe, the Middle East, and Canada",
    abbreviation: "AE",
    areaCodes: [],
    territory: true, // to exclude from list of states with purchasable numbers
  },
  {
    name: "Armed Forces: Americas (except Canada)",
    abbreviation: "AA",
    areaCodes: [],
    territory: true,
  },
  {
    name: "Armed Forces: Pacific",
    abbreviation: "AP",
    areaCodes: [],
    territory: true,
  },
] as const;

export type StateAbbreviation = (typeof statesData)[number]["abbreviation"];

export type State = Readonly<{
  name: string;
  alternateNames?: readonly string[];
  abbreviation: StateAbbreviation;
  areaCodes: readonly string[];
  territory?: boolean;
}>;

export const STATES = Array.from(statesData).sort((a, b) =>
  a.name.localeCompare(b.name)
) as State[];

export const STATE_NAMES = STATES.map(state => state.name);
export const STATE_ABBREVIATIONS: string[] = statesData.map(
  state => state.abbreviation
);

export const STATES_BY_ABBREVIATION = Object.fromEntries(
  STATES.map(state => [state.abbreviation, state])
) as Record<StateAbbreviation, State>;

export const STATE_NORMALIZED_NAME_TO_ABBREVIATION: Record<
  string,
  StateAbbreviation
> = Object.fromEntries(
  STATES.flatMap(state => {
    const normalizedName = normalizeStateName(state.name);
    return [
      [normalizedName, state.abbreviation],
      ...(state.alternateNames?.map(name => [
        normalizeStateName(name),
        state.abbreviation,
      ]) || []),
    ];
  })
);

export const ALL_AREA_CODES: Set<string> = new Set(
  STATES.flatMap(state => state.areaCodes)
);

export const STATES_WITH_AREA_CODES = STATES.filter(
  state => state.areaCodes.length > 0
);
